<template>
  <div id="app">
    <header v-if="showMenu" class="main-bg-color header">
      <img src="./assets/images/logo.png" alt @click="toHome" />
      <div class="tittle" @click="toHome">
        <h2 class="text-color">南沙区食品安全工作信息互动平台</h2>
      </div>
      <div class="func">
        <el-badge :value="length" class="item">
          <el-button size="small" @click="goMessage">消息</el-button>
        </el-badge>
        <el-dropdown>
          <span class="el-dropdown-link">
            <span v-if="userInfo!= null" class="text-color">您好，{{userInfo.nickname}}</span>
            <i class="el-icon-arrow-down el-icon--right" style="font-size:12px;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="set">设置</el-dropdown-item>
            <el-dropdown-item divided @click.native="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <el-container style="height: 92vh;" v-if="showMenu">
      <el-aside width="200px">
        <el-menu
          router
          :default-active="activeNav"
          background-color="#2c69dc"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu v-for="item in userRouter" :key="item.par_index" :index="item.par_index">
            <template slot="title">
              <span>{{item.title}}</span>
            </template>
            <el-menu-item
              v-for="child in item.child_items"
              :key="child.index"
              :index="child.index"
              @click="handleOpen(child.index)"
            >
              <i :class="child.icon" style="color:#fff;"></i>
              {{child.name}}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 组件展示区域 -->
      <component :is="component" :activeNav="activeNav"></component>

      <!-- <mission :activeNav="activeNav" v-show="loginStatus==true"></mission> -->
      <div class="router-view">
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </div>
    </el-container>
    <!-- 登录页面 -->
    <router-view v-if="!showMenu"></router-view>
  </div>
</template>

<script>
import mission from "./components/mission";
import {readUserMessage} from "@/api"
export default {
  name: "App",
  data() {
    return {
      showMenu: true,
      activeNav: "/index",
      component: ""
    };
  },
  components: { mission },
  methods: {
    handleOpen(key) {
      //console.log(key);
      this.activeNav = key;
      //console.log(key);
    },
    toHome() {
      this.$router.push({ name: "index" });
      this.activeNav = "/index";
    },
    exit() {
      this.$message({
        message: "用户登出",
        type: "info",
        center: true
      });
      this.$store.dispatch("logOut").then(() => {
        this.$router.push({
          path: "/"
        });
      });
    },
    set() {
      this.$router.push({ name: "set" });
    },
    goMessage(){
      var message=this.$store.state.user.message
      console.log("message",message)
      for (let i = 0; i < message.length; i++) {
        if(message[i].tag=="[通用任务][任务删除]"){
          const o={}
          o.id=message[i].id
          readUserMessage(o).then(res=>{
            this.$set(message[i],"isRead",1)
          })
        }
        
      }
      this.$router.push({name:"message"});
      
    }
  },
  watch: {
    $route(to) {
      if (to.name == "login") {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
      if (to.name == "notFound") {
        this.showMenu = false;
      }
      //防止页面刷新
      if (to.name == "index") {
        this.activeNav = "/index";
      }
      if (to.name == "user") {
        console.log($route);
        this.activeNav = "/user";
      }
      if (to.name == "common") {
        this.activeNav = "/common";
      }
      if (to.name == "commonShow") {
        this.activeNav = "/common";
      }
      if (to.name == "commonEdit") {
        this.activeNav = "/common";
      }
    },
    loginStatus(val) {
      //登陆成功之后再去动态加载mission组件
      if (val) {
        this.component = "mission";
        this.activeNav = "/index"; //解决切换用户登录的时候有可能不展示mission页
      }
    }
  },
  created() {
    //解决页面刷新vuex丢失
    let store = sessionStorage.getItem("store");
    if (store !== null) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, JSON.parse(store))
      );
      //this.$store.commit("LOGINSTATUS", JSON.parse(store).user.loginStatus);
      //console.log(this.$store.state)
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    if (this.$route.path == "/") {
      this.showMenu = false;
    }
  },
  computed: {
    loginStatus: function() {
      return this.$store.state.user.loginStatus;
    },
    userInfo: function() {
      return this.$store.state.user.userInfo;
    },
    userRouter: function() {
      // 获取用户路由
      //console.log(this.$store.state.user.userRouter)
      return this.$store.state.user.userRouter;
    },
    //获取用户收到的消息（暂时为管理员即将过期,已过期的消息）
    message:function(){
      // console.log("message",this.$store.state.user.message)
      return this.$store.state.user.message;
    },
    length(){
      var length=0;
      for (let i = 0; i < this.$store.state.user.message.length; i++) {
        if(!this.$store.state.user.message[i].isRead){
          length++;
        }
        
      }
      return length
    }
  }
};
</script>
<style lang="less" scope>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.tittle {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.el-submenu {
  box-sizing: border-box;
  //height: 92vh;
}

.el-menu .el-submenu:first-child {
  border-top: 2px solid #225dd1 !important;
}

.el-submenu__title .el-submenu__icon-arrow {
  color: white !important;
}
.el-dropdown-link .el-icon--right {
  color: white !important;
}
.main-bg-color {
  background-color: #2c69dc;
}

.text-color {
  color: #fff;
}

.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.el-menu {
  height: 100%;
}

body {
  margin: 0;
}

#app {
  height: 100vh;
  background-color: #e9edf8;
  box-sizing: border-box;
}

header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8vh;
  padding: 0 20px;
}

header img {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  cursor: pointer;
}

// .logo {
//   width: 40px;
//   height: 40px;
// }

.func {
  position: absolute;
  right: 20px;
}
.item{
  margin-right:5px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.router-view {
  overflow: auto;
  display: block;
  width: 100%;
  margin: 10px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter,
.slide-fade-leave,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

// .el-submenu .el-menu-item {
//   min-width: 200px !important;
// }
.el-submenu .el-menu-item {
  min-width: 180px !important;
}
.el-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.el-radio__input.is-checked .el-radio__inner,
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #225dd1 !important;
  background: #225dd1 !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label {
  color: #225dd1 !important;
}
.el-table__fixed-right::before, .el-table__fixed::before{
  width: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue